import { toast } from 'sonner';

export const CREDIT_DOCUMENTS_UPLOAD_TITLE = 'Documentos de la actualización';

export const CREDIT_DOCUMENTS_REQUIRED_MESSAGE = 'Debe adjuntar al menos un documento de crédito';

export const validateCreditDocumentsRequired = (files: File[]): boolean => {
    if (files.length > 0) {
        return true;
    }

    toast.error(CREDIT_DOCUMENTS_REQUIRED_MESSAGE);
    return false;
};
